// extracted by mini-css-extract-plugin
export default {"navSider":"NavSider_nav-sider__bO9x4","logo":"NavSider_logo__joCoJ"};